import React from 'react'
import { withRouter } from "react-router-dom";
import './Lugares.css'
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Lugar from './Lugar.js';
import ACCESS from '../../../ACCESS';

// class Lugares extends Component {
class Lugares extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'lugar/filter', deleteUrl: 'lugar/delete', deleteField: 'od_lugar_nombre', modUrl: '/Catalogo/Lugar' },
      TableOp.Table('Lugares', [
        { label: 'Clave', id: 'od_lugar' },
        { label: 'Lugar', id: 'od_lugar_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_LUGARES.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_LUGARES.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  // cargarDatos = async (page = this.page, limit = this.rpp) => {
  //   let Res = await Http.get(`lugares/filter?p=${page}&l=${limit}`);
  //   this.setState({ lugaresTable: { ...this.state.lugaresTable, rows: Res.data.rows, total: Res.data.total } });
  // }

  // eliminar = async (row) => {
  //   this.deleteRow = row;
  //   this.setState({
  //     dialog: {
  //       title: `¿Borrar el registro ${row.od_lugar_nombre}?`,
  //       body: '',
  //       options: ['Sí', 'No'],
  //       show: true,
  //     }
  //   })
  // }

  // dialogClose = async (op) => {
  //   this.setState({ dialog: { ...this.state.dialog, show: false } })
  //   if (op === 1) {
  //     let Res = await Http.post('lugar/delete', this.deleteRow);
  //     if (!Res.error) {
  //       this.cargarDatos();
  //     }
  //   }
  // }

  // action = (id, row) => {
  //   if (id === 'edit') {
  //     this.props.history.push(`/Catalogos/Lugar/${row.id}`)
  //   }
  //   else if (id === 'delete') {
  //     this.eliminar(row)
  //   }
  // }

  // pag = (page, rpp) => {
  //   this.cargarDatos(page, rpp);
  // }

  render() {
    // console.log(this.state.tableData);

    return (
      <div>
        <div>
          {
             
          <Lugar  onSave={() => {this.table()}}></Lugar>
        }
        {
           
          <this.TableRender  />
        }
          {/* <div className="table-box">
            <Table table={this.state.lugaresTable} onAction={this.action} pag={this.pag}></Table>
            <Dialog dialog={this.state.dialog} onClose={this.dialogClose} />
          </div> */}
        </div>
      </div>
    )
  }
}

export default withRouter(Lugares)